// removed by extract-text-webpack-plugin
module.exports = {"root":"credit-chart--root--FugGqHKY","info":"credit-chart--info--25WBpwOf","transaction":"credit-chart--transaction--2YImOLYx","breakdown":"credit-chart--breakdown--23Cwr7NS","name":"credit-chart--name--1WDGAWEr","amount":"credit-chart--amount--1ep1l9nQ","admin":"credit-chart--admin--Unxmf--d"};


//////////////////
// WEBPACK FOOTER
// ./components/credit-chart/styles.css
// module id = ./components/credit-chart/styles.css
// module chunks = 0